exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".databases-example span {\n    font-weight: bold;\n}\n\n.ibox-content > h4 {\n    padding: 15px 6px;\n    background: #ccc;\n    cursor: pointer;\n}\n.ngdialog.ngdialog-theme-default.ngdialg-padding {\n    padding-bottom: 20px;\n    padding-top: 20px;\n}\n.ngdialog.ngdialog-theme-default.ngdialog-sm .ngdialog-content {\n    width: 400px !important;\n}\n.ngdialog.ngdialog-theme-default.ngdialog-md .ngdialog-content {\n    width: 800px !important;\n}\n\n.btn-toggal{\n    width: 23px;\n}\n.btn-toggal:focus{\n    border: 1px solid #afafaf !important;\n    background: #e8e8e8 !important;\n}\n.white-space-inherit .table > tbody > tr > td{\n    white-space: inherit;\n    width: 20%;\n}\n.break-word {\n    word-break: break-all;\n}\n.inventory-setup .ibox-content > h4 i {\n    float: right;\n}\n.inventory-setup .ibox-content > h4 {\n    clear:both;\n    overflow: hidden;\n}\n.moment-picker .moment-picker-container {\n    position: relative;\n}\n\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./packages/custom/databases/public/assets/css/databases.css
// module id = 723
// module chunks = 0